<template>
  <div class="notFound">
    404 - Page not found
  </div>
</template>

<script>
  export default {
    components: {
      
    }
  }
</script>

<style scoped>
.notFound {
  display:flex;
  justify-content:center;
  align-items:center;
  margin-top: 5rem;
  margin-bottom: 1.5rem;
  width: 100%;
  height: 10rem;
  font-size: 4rem;
  text-align: center;
  -webkit-animation: home 1s forwards; /* Chrome, Safari, Opera */
  animation: home 1s forwards;
}
</style>
